import React, { FunctionComponent,ReactChild } from 'react';
import { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';

import { fetchCallLogs, fetchUserCallLogs } from '../../Services/contacts';

import TopBar from '../../Components/TopBar/TopBar';
import commonStyle from '../common.module.css';
import Loading from '../../Components/Loading/Loading';
import Cookies from 'universal-cookie';
import { combineReducers } from "redux";
import {
  booleanObject,
  CALLLOG_COLUMNS,
  datesField,
} from '../../Values/tables';
import { getDateString, searchCallLogs } from '../../Values/utils';
import CustomTable from '../../Components/CustomTable/CustomTable';
import axios from 'axios';
import moment from 'moment';
import {
  setClearFilter,
  setFilterObject,
  setRefreshCallLogs,
  showSnackbarAction,
  // setCallLogDrillDownClearFilter
} from '../../Redux/actions';
import ApiCustomTable from '../../Components/CustomTable/ApiCustomTable';
import ApiTopBar from '../../Components/TopBar/ApiTopBar';
import { calllogFilterValues, localstorageKey, url } from '../../Values/constants';
import { themeColors } from '../../Components/theme';
import PopUpBox from "../AuditLogs/PopUpBox";
import organizationUserReducer from '../../Redux/reducers/organizationUserReducer';
import { firestore } from '../../Firebase';
import axiosHandler from '../../Services/axiosHandler';
import { googleAnalytics } from '../../Services/users';

type props = {
  user: any;
  contacts: any;
  history: any;
  role: any;
  organizationUsers: any[];
  teamLeadUsers: any;
  filterObject: any;
  filterSort: any;
  refreshCallLogs: boolean;
  searchString: string;
  theme: any;
  authToken:any;
};

let isFinished = false;

const DrilldownCallLogsPanel: FunctionComponent<props> = ({
  user,
  contacts,
  history,
  role,
  organizationUsers,
  teamLeadUsers,
  filterObject,
  searchString,
  filterSort,
  refreshCallLogs,
  theme,
  authToken,
}) => {
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [callList, setCallList] = useState<any[]>();
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [searchedItem, setsearchedItem] = useState('');
  const [columnModal, setColumnModal] = useState(false);
  const [originalData, setOriginalData] = useState<any[] | undefined>(
    undefined
  );
  const [contactsMap, setcontactsMap] = useState<any>(undefined);

  const [lastPage, setLastPage] = useState(-1);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [load, setLoad] = useState(false);
  const [allCallLogs, setAllCallLogs] = useState(false);
  const [totalCounts, setTotalCounts] = useState<any>();
  const [userMap, setUserMap] = useState<any>({});
  const [showImportModal, setShowImportModal] = useState(false);
  const [localStorageData, setLocalStorageData] = useState<any>({});
  const [filterApiCount, SetFilterApiCount] = useState<any>({});
  const [drillDownCount, SetDrillDownCount] = useState<any>({});
  const dispatcher = useDispatch();
  const [auditLog, setAuditLog] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const cookies = new Cookies();
  const [userEmail, setUserEmail] = useState<any>(undefined);
  const [showColumns, setShowColumns] = useState<any>(null);
  const [isGACalled, setIsGACalled] = useState<any>(false);

  const data: any[] = [];
  // const [filtername, setName] = useState<any>('');
  

const fetchUserData = (()=>{
const subscribe = firestore
    .collection('users')
    .where('organization_id', '==', user.organization_id)
    .onSnapshot((users) => {
      if (users) {
        users.forEach((users) => {
          data.push(users.data());
        });
        if (data) {
          // To store info of user
          let emailInfo: { [key: string]: string } = {};
          data.forEach((user: any) => {
            emailInfo[user.user_email]=user;
          });
          setUserEmail(emailInfo)
        }
      } 
    });
})
  // let userId = cookies.get("uId");
  useEffect(() => {
    if(user.organization_id){
      fetchUserData()
    }
  }, [organizationUsers,user]);

  useEffect(() => {
    var key: any;
    const preserveLocalStorageFields = localstorageKey;
    for (var i = 0; i < localStorage.length; i++) {
      key = localStorage.key(i);

      if (!preserveLocalStorageFields.includes(key) && key !== 'columns' && key !== 'callDrilldownData'  && key !== 'isLightMode' && key !== 'totalMonths' && key !== 'lastAlertTime') {
        localStorage.removeItem(key);
      }
    }

    dispatcher(setClearFilter(true));
    // dispatcher(setCallLogDrillDownClearFilter(true));
    const savedData = localStorage.getItem('callDrilldownData');
    if (savedData) {
      setLocalStorageData(JSON.parse(savedData));
    }
  }, [searchString]);
  
  const callApi = async (
    paginate?: boolean,
    localPageSize?: Number,
    localPage?: Number
  ) => {
    if (isFinished === true) {
      return;
    } else {
      setLoad(true);
      const filters: { [key: string]: any[] } = { ...localStorageData.callFilter };
      let ownerEmailArr:any={};
      let own:any={};
      Object.keys(filterObject).forEach((item) => {
        if (filterObject && filterObject[item].length > 0) {
          filters[item] = filterObject[item];
        }
      });
      for (const [key, value] of Object.entries(localStorageData.leadFilter)) {
        let key1=key.split(".")[1];
        if(key1==="team" || key1==="branch" || key1==="reporting_to"){
          ownerEmailArr["leadUserFilter"] = ownerEmailArr["leadUserFilter"] || {};
        ownerEmailArr["leadUserFilter"][key] = value;
        }else if (key1==="contact_owner_email"){
          own["contact_owner_email"]=localStorageData.leadFilter[key];
        }else if(key1==="employee_name" || key1==="employee_id"){
           ownerEmailArr["contact_owner_email"]=value
        }
      }
      let records = localPageSize ? localPageSize : pageSize;
      const apiData = {
        uid: localStorageData.uid,
        page: localPage ? localPage : page + 1,
        searchString: searchString,
        sort:
          Object.keys(filterSort).length === 0
            ? { created_at: '-1' }
            : filterSort,
        pageSize: localPageSize ? localPageSize : pageSize,
        taskFilter: {},
        leadFilter: {...own},
        callFilter: localStorageData.role === true ? { ...filters,  ...ownerEmailArr } : filters,
        role: localStorageData.role,
        teamUids: localStorageData.teamUids ? localStorageData.teamUids : []
      };
      SetDrillDownCount(filters);
      SetFilterApiCount(apiData);
      try {
        // axios.defaults.headers.common['x-access-token'] =
        //   authToken
        const res = await axiosHandler.post(
          url + '/callLogs/drillDownSearch',
          apiData
        );

        let data: any[] = res.data;
        if (data.length < records && paginate) {
          isFinished = true;
          setLastPage(page);
        }

        data.forEach((task) => {
          task.contactId = task.leadId;
          task.reporting_to = userMap[task.contact_owner_email];
           if (userEmail && userEmail[task.contact_owner_email]) {
             let info=userEmail[task.contact_owner_email];
          if(info){
            task.employee_id=info.employee_id?info.employee_id:"";
              if(info.user_first_name || info.user_last_name){
                task.employee_name=info.user_first_name+" "+info.user_last_name;
              }
            }
          }
          delete task['Id'];
          Object.keys(task).forEach((key) => {
            if (datesField.includes(key) && task[key] !== '') {
              if (task[key] !== null) {
                task[key] = moment(task[key]);
              } else {
                task[key] = '';
              }
            }
          });
        });

        if (paginate && filterData) {
          let newData = [...filterData, ...data];
          setFilterData(newData);
        } else {
          // setName(data[0].employee_id)
          setFilterData(data);
        }
        setLoad(false);
      } catch (error){
        setFilterData([]);
        setLoad(false);
        // dispatcher(showSnackbarAction('Please Try Again!!', 'error'));
      }
    }
  };

  useEffect(() => {
    if (localStorageData.uid === undefined) {
      setFilterData([]);
      return;
    }
    if (userMap === undefined) {
      setFilterData([]);
      return;
    }
    isFinished = false;
    setLastPage(-1);
    if (page !== 0) {
      setPage(0);
    }
    if(authToken){
      callApi(false, pageSize, 1);
    }
  }, [localStorageData, filterObject,authToken,userEmail]);

  useEffect(() => {
    if (
      filterData &&
      filterData.length <= (page + 1) * pageSize &&
      isFinished === false
    ) {
      if (page === 0) {
        if(authToken){
          callApi(false, pageSize);
        }
      } else {
        if(authToken){
          callApi(true, pageSize);
        }
      }
    }
  }, [page, pageSize,authToken,userEmail]);



  useEffect(() => {
    if (user === undefined || user.uid === undefined) {
      setFilterData([]);
      return;
    }
    if(authToken){
      callCountApi();
    }
  }, [refreshCallLogs, user.uid, filterApiCount, drillDownCount,authToken]);

  useEffect(() => {
    if (refreshCallLogs === true) {
      if(authToken){
        callApi();
      getCallLogsFilter();
      dispatcher(setRefreshCallLogs(false));
      }
    }
  }, [refreshCallLogs,authToken,userEmail]);

  // useEffect(()=>{
  //   const storedValue = localStorage.getItem('calllogShowFilterValues');
  //   setShowColumns(storedValue);
  //   getCallLogsFilter();
  // },[localStorage.getItem('calllogShowFilterValues'),showColumns])

  const callCountApi = async () => {

    const { page, pageSize, searchString, sort, ...objFilterData } = filterApiCount;
    // axios.defaults.headers.common['x-access-token'] =
    //   authToken
    const res = await axiosHandler.post(url + '/callLogs/callLogsDrillDownCount', objFilterData);
    if(res.data[0] === undefined){
      setTotalCounts(0);
    }
    else{
      setTotalCounts(res.data[0].total);
    }
  };

  const getCallLogsFilter = async () => {
    // const uId = localStorageData.uid
    // axios.defaults.headers.common['x-access-token'] =
    //   authToken
    const res = await axiosHandler.post(url + '/callLogs/filterValues', {
      uid: localStorageData.uid,
      // uid: user.uid,
      // uid: localStorageData.source === true && localStorageData.role === false ? userId : uId,
      role: localStorageData.role,
      teamUids: localStorageData.teamUids ? localStorageData.teamUids : [],
      showColumns:showColumns === null?calllogFilterValues:JSON.parse(showColumns)
    });
    const userdetail = await axiosHandler.post(url + "/users/fetchSpecificData", {
      organization_id: user.organization_id,
      uid: user.uid,
      });

    if (res.data[0]) {
      dispatcher(setFilterObject({ ...res.data[0], ...booleanObject,'employee_name':userdetail.data.data.Employee_Name, 'employee_id':userdetail.data.data.Employee_id,}));
    } else {
      dispatcher(setFilterObject({}));
    }
  };

  useEffect(() => {
    const storedValue = localStorage.getItem('calllogShowFilterValues');
    setShowColumns(storedValue);
    if (user === undefined || user.uid === undefined) {
      return;
    }
    if(user && authToken){
      getCallLogsFilter();
    }
  }, [user,authToken,localStorage.getItem('calllogShowFilterValues'),showColumns]);
  const exportFile = () => {
    let data: any[] = [];
    // console.log(selectedRowsData,"gbehbdibgibt")
    if (selectedRowsData.length !== 0) {
      selectedRowsData.forEach((item, index) => {
        data.push({
          "S.No":index+1,
          "Customer Name":item?.customer_name,
          "Lead Assignee Email":item?.contact_owner_email,
          "Lead Stage":item?.stage,
          "Project":item?.project,
          "Location":item?.location,
          "Budget":item?.budget,
          "Contact Number": item?.contact_no,
          "Inventory Type":item?.inventory_type,
          "Transfer Status": item?.transfer_status,
          "Created By":item?.created_by,
          "Duration": item?.duration,
          "Created On":getDateString(item?.created_at),
          "Employee ID":item.employee_id,
          "Lead Assignee": item.employee_name,
          "Lead State": item.state,
        });
      });
    }
    return data;
  };
  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('CalLog_DrillDown_Screen',user)
      }
    }
  },[user])
  return (
    <div style={{ height: "100vh", ...containerStyles }}>
      <div className={commonStyle.topBar} style={containerStyles}>
        <ApiTopBar
          history={history}
          title={'Add Call Logs'}
          path={'/addContacts'}
          onClick={() => {
            setShowImportModal(true);
          }}
          onChange={(val) => setsearchedItem(val)}
          filterText={'Status'}
          setColumnModal={(data) => setColumnModal(data)}
          show={true}
          showStatusBox={true}
          searchedString={searchString}
          onExport={exportFile}
          titleDrillDown={'Drill Down'}
          selectedRows={selectedRows}
          setAuditLog={setAuditLog}
          isOtpVerified={isOtpVerified}
          panel = "call logs drilldown"
        />
      </div>
      <div className={commonStyle.parent} style={{ height: "81%", ...containerStyles }}>
        {/* {filtername === undefined && <Loading />} */}
        {filterData === undefined && <Loading />}
        {load === true && <Loading />}
        <ApiCustomTable
          tableColumns={CALLLOG_COLUMNS}
          tableRows={filterData}
          selectedRows={selectedRows}
          setSelectedRows={(data) => setSelectedRows(data)}
          tableType="CallLogs"
          showColumnModal={columnModal}
          hideColumnModal={() => setColumnModal(false)}
          selectedRowsData={selectedRowsData}
          setSelectedRowsData={(data) => {
            // console.log(data)
            setSelectedRowsData(data)}}
          setPage={(val) => setPage(val)}
          setPageSize={(val) => setPageSize(val)}
          callApi={callApi}
          pageSize={pageSize}
          page={page}
          isFinished={isFinished}
          totalCount={totalCounts}
          lastPage={lastPage}
          DrillDownpanel = "call logs drilldown"
        />
        {auditLog && (
              <PopUpBox
              open={auditLog}
              close={() => setAuditLog(false)}
              setIsOtpVerified={setIsOtpVerified}
              setAuditLog={setAuditLog}
              onExport={exportFile}
              selectedRows={selectedRows}
              panel = "call logs drilldown"
              />)}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    // filterObject: state.filter,
    // filterSort: state.filterSort,
    filterObject: state.callLogDrillDownFilter,
    filterSort: state.callLogDrillDownfilterSort,
    searchString: state.searchItem.callLogsSearchString,
    refreshCallLogs: state.refresh.refreshCallLogs,
    theme: state.theme.isLightMode,
    authToken:state.user.authToken,
  };
};
export default connect(mapStateToProps)(DrilldownCallLogsPanel);
